//src/shared/layouts/AdminLayout.tsx - ОБНОВЛЕННАЯ ВЕРСИЯ с меню Амбассадоры
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Badge, Button } from 'antd';
import { 
  DashboardOutlined, 
  ShoppingCartOutlined, 
  AppstoreOutlined,
  SettingOutlined,
  BarChartOutlined,
  LogoutOutlined,
  UserOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  ToolOutlined,
  StarOutlined,
  MessageOutlined,
  TeamOutlined, // ✨ НОВАЯ ИКОНКА для амбассадоров
} from '@ant-design/icons';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const { Header, Sider, Content } = Layout;

export const AdminLayout: React.FC = () => {
  const location = useLocation();
  const { permissions } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Определение размера экрана
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setCollapsed(true);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/dashboard">Дашборд</Link>,
    },
    ...(permissions?.can_manage_orders ? [{
      key: '/orders',
      icon: <ShoppingCartOutlined />,
      label: <Link to="/orders">Заказы</Link>,
    }] : []),
    ...(permissions?.can_manage_orders ? [{
      key: '/feedbacks',
      icon: <StarOutlined />,
      label: <Link to="/feedbacks">Отзывы</Link>,
    }] : []),
    ...(permissions?.can_manage_orders ? [{
      key: '/chats',
      icon: <MessageOutlined />,
      label: (
        <Link to="/chats" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>Чаты</span>
          <Badge 
            count={5} 
            size="small"
            style={{ 
              marginLeft: 8,
              backgroundColor: '#ff4d4f'
            }}
          />
        </Link>
      ),
    }] : []),
    // ✨ НОВЫЙ ПУНКТ МЕНЮ: Амбассадоры (только для Admin)
    ...(permissions?.can_manage_users ? [{
      key: '/ambassadors',
      icon: <TeamOutlined />,
      label: <Link to="/ambassadors">Амбассадоры</Link>,
    }] : []),
    ...(permissions?.can_manage_manufacturing ? [{
      key: '/production',
      icon: <AppstoreOutlined />,
      label: <Link to="/production">Производство</Link>,
    }] : []),
    ...(permissions?.can_view_full_dashboard ? [{
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: <Link to="/analytics">Аналитика</Link>,
    }] : []),
    ...(permissions?.can_manage_catalog ? [{
      key: '/config',
      icon: <SettingOutlined />,
      label: <Link to="/config">Конфигурация</Link>,
    }] : []),
    ...(permissions?.can_manage_users ? [{
      key: '/settings',
      icon: <ToolOutlined />,
      label: <Link to="/settings">Настройки</Link>,
    }] : []),
  ];

  const userMenuItems = [
    {
      key: 'profile',
      label: 'Профиль',
      icon: <UserOutlined />,
    },
    {
      key: 'logout',
      label: 'Выйти',
      icon: <LogoutOutlined />,
      onClick: () => {
        localStorage.removeItem('admin_token');
        window.location.href = '/auth/login';
      },
    },
  ];

  // Ширина sidebar
  const siderWidth = collapsed ? 80 : 220;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Боковая панель */}
      <Sider 
        theme="dark" 
        width={siderWidth}
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        trigger={null}
        style={{ 
          position: isMobile ? 'fixed' : 'fixed',
          height: '100vh', 
          left: 0, 
          top: 0,
          zIndex: 1000,
          transition: 'all 0.2s'
        }}
        collapsedWidth={isMobile ? 0 : 80}
      >
        <div style={{ 
          height: 64, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          borderBottom: '1px solid #434343',
          padding: '0 16px'
        }}>
          {!collapsed ? (
            <h2 style={{ 
              color: 'white', 
              margin: 0, 
              fontSize: '16px',
              whiteSpace: 'nowrap'
            }}>
              DomChef Admin
            </h2>
          ) : (
            <h2 style={{ 
              color: 'white', 
              margin: 0, 
              fontSize: '16px'
            }}>
              DC
            </h2>
          )}
        </div>
        
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          style={{ border: 'none' }}
          inlineCollapsed={collapsed}
        />
      </Sider>

      {/* Основная область */}
      <Layout style={{ 
        marginLeft: isMobile && collapsed ? 0 : siderWidth,
        transition: 'margin-left 0.2s',
        minHeight: '100vh',
        width: `calc(100vw - ${isMobile && collapsed ? 0 : siderWidth}px)` // ← ДОБАВИТЬ ЭТУ СТРОКУ
      }}>
        {/* Шапка */}
        <Header style={{ 
          background: '#fff', 
          padding: '0 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 1px 4px rgba(0,21,41,.08)',
          position: 'sticky',
          top: 0,
          zIndex: 999
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontSize: '16px', width: 40, height: 40 }}
            />
            
            <h1 style={{ 
              margin: 0, 
              fontSize: isMobile ? '16px' : '20px',
              whiteSpace: 'nowrap'
            }}>
              {isMobile ? 'DomChef' : 'Админ-панель DomChef'}
            </h1>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Badge count={5} size="small">
              <Avatar icon={<UserOutlined />} />
            </Badge>
            
            {!isMobile && (
              <Dropdown 
                menu={{ items: userMenuItems }}
                placement="bottomRight"
              >
                <span style={{ cursor: 'pointer' }}>
                  Администратор
                </span>
              </Dropdown>
            )}
          </div>
        </Header>

        {/* Контент */}
        <Content style={{ 
        padding: isMobile ? '16px' : '24px',  // Увеличили боковые отступы
        background: '#f5f5f5',
        minHeight: 'calc(100vh - 64px)'  // Высота на весь экран минус header
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 8,
            padding: isMobile ? '16px' : '24px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            maxWidth: '100%',  // Растягиваем на всю ширину
            margin: '0 auto'
          }}>
            <Outlet />
          </div>
        </Content>
      </Layout>

      {/* Overlay для мобильных */}
      {isMobile && !collapsed && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            zIndex: 999
          }}
          onClick={() => setCollapsed(true)}
        />
      )}
    </Layout>
  );
};